const parametrizationSupplyHeader = [
  {
    group: 'Id',
    columns: [
      {
        name: 'Id',
        id: 'id-id',
        show: false,
        ignore: true
      }
    ]
  },
  {
    group: 'Centro',
    columns: [
      {
        name: 'Código',
        id: 'centro-codigo',
        show: true
      },
      {
        name: 'Nome',
        id: 'centro-id',
        show: true
      }
    ]
  },
  {
    group: 'Produto',
    columns: [
      {
        name: 'Código do Fornecedor',
        id: 'fornecedor-codigo-produto',
        show: true
      },
      {
        name: 'Código',
        id: 'produto-id',
        show: true
      },
      {
        name: 'Nome',
        id: 'produto-nome',
        show: true
      },
      {
        name: 'Status',
        id: 'produto-status',
        show: true
      },
      {
        name: 'Curva',
        id: 'produto-curva-abc',
        show: true
      },
      // {
      //   name: 'Cluster Centro',
      //   id: 'parametros-cluster-centro',
      //   show: true
      // },
      // {
      //   name: 'Cluster Produto',
      //   id: 'parametros-cluster-produto',
      //   show: true
      // },
      {
        name: 'Grupo de Separação',
        id: 'produto-grupo-separacao',
        show: true
      },
      // {
      //   name: 'Gerente Produto Id',
      //   id: 'gerente-produto-id',
      //   show: true
      // },
      {
        name: 'Gerente Produto',
        id: 'gerente-produto-desc',
        show: true
      },
      // {
      //   name: 'Mundo',
      //   id: 'produto-mundo',
      //   show: true
      // },
      {
        name: 'Categoria Compacta',
        id: 'produto-categoria-compacta',
        show: true
      },
      {
        name: 'Sub Categoria',
        id: 'produto-sub-categoria',
        show: true
      },
      {
        name: 'Marca',
        id: 'produto-marca',
        show: true
      },
      {
        name: 'Essência',
        id: 'produto-essencia',
        show: true
      }
    ]
  },
  {
    group: 'Parâmetros',
    isAlwaysVisible: true,
    columns: [
      {
        name: 'Tipo de Suprimento',
        id: 'parametros-tipo-suprimentos',
        show: true,
        isRequired: true,
        isAlwaysVisible: true,
        tooltip: 'Requisito para a REAB/Compra'
      },
      {
        name: 'Abastecer',
        id: 'parametros-abastecer',
        show: true,
        isAlwaysVisible: true
      },
      {
        name: 'EMax',
        id: 'parametros-emax',
        show: true,
        isNumeric: true,
        isRequired: true,
        isAlwaysVisible: true,
        tooltip: 'Requisito para a REAB/Compra'
      },
      {
        name: 'Lead Time',
        id: 'parametros-lead-time',
        show: true,
        isNumeric: true,
        isRequired: true,
        isAlwaysVisible: true,
        tooltip: 'Requisito para a REAB/Compra'
      },
      {
        name: 'Incluir Projeções de Venda',
        id: 'parametros-previsao-lead-time',
        show: true,
        isNumeric: true
      },
      {
        name: 'Utilizar Ponto de Pedido',
        id: 'parametros-utilizar-ponto-pedido',
        show: true,
        isNumeric: true
      },
      {
        name: 'Frequência de Pedidos',
        id: 'parametros-frequencia-pedidos',
        show: true,
        isNumeric: true,
        isRequired: true,
        isAlwaysVisible: true,
        tooltip: 'Requisito para a REAB/Compra'
      },
      {
        name: 'Lote Mínimo CD',
        id: 'parametros-lote-minimo-cd',
        show: true,
        isNumeric: true,
        isRequired: true,
        isAlwaysVisible: true,
        tooltip: 'Requisito para a REAB/Compra'
      },
      {
        name: 'Lote Múltiplo',
        id: 'parametros-lote-multiplo',
        show: true,
        isNumeric: true,
        isRequired: true,
        isAlwaysVisible: true,
        tooltip: 'Requisito para a REAB/Compra'
      },
      {
        name: 'Estoque Mínimo',
        id: 'parametros-estoque-minimo',
        show: true,
        isNumeric: true,
        isRequired: false
        // isAlwaysVisible: true,
        // tooltip: 'Requisito para a REAB/Compra'
      },
      {
        name: 'Utilizar Estoque Mínimo',
        id: 'parametros-utilizar-estoque-minimo',
        show: true,
        isNumeric: true
      }
      // {
      //   name: 'Estoque Arbitrado',
      //   id: 'parametros-estoque-arbritado',
      //   show: false
      // }
    ]
  },
  {
    group: 'Politica de Estoque de Segurança',
    columns: [
      {
        name: 'Arbitrada',
        id: 'politica-arbritada',
        show: true,
        isNumeric: true,
        isRequired: true,
        isAlwaysVisible: true,
        tooltip: 'Requisito para a REAB/Compra'
      },
      {
        name: 'Ponto de Pedido',
        id: 'parametros-ponto-pedido-dias',
        show: true,
        isNumeric: true,
        isRequired: true,
        isAlwaysVisible: true,
        tooltip: 'Requisito para a REAB/Compra'
      },
      {
        name: 'Otimizada',
        id: 'politica-otimizada',
        show: true,
        isNumeric: true
      },
      {
        name: 'Utilizar Otimizada',
        id: 'politica-utilizar-otimizada',
        show: true
      }
    ]
  },
  {
    group: 'Fornecedor',
    columns: [
      {
        name: 'Código',
        id: 'fornecedor-codigo',
        show: true
      },
      {
        name: 'Nome',
        id: 'fornecedor-nome',
        show: true
      },
      {
        name: 'Código do Produto',
        id: 'fornecedor-codigo-produto',
        show: true
      }
    ]
  },
  {
    group: 'Cd de Origem',
    columns: [
      {
        name: 'Código',
        id: 'cd-origem-codigo',
        show: true,
        isConditionalRequired: true,
        tooltip: 'Obrigatório quando centro for diferente de 1500'
      },
      {
        name: 'Nome',
        id: 'cd-origem-nome',
        show: true,
        isConditionalRequired: true,
        tooltip: 'Obrigatório quando centro for diferente de 1500'
      }
    ]
  },
  {
    group: 'Venda Média',
    columns: [
      {
        name: 'Total Centro (4M)',
        id: 'venda-media-total',
        show: true,
        isNumeric: true
      },
      {
        name: 'Retira Centro (4M)',
        id: 'venda-media-retira',
        show: true,
        isNumeric: true
      }
    ]
  },
  {
    group: 'Ruptura',
    columns: [
      {
        name: '0 Dias',
        id: 'ruptura-zero-dias',
        show: true
      },
      {
        name: '10 Dias',
        id: 'ruptura-dez-dias',
        show: true
      }
    ]
  },
  {
    group: 'Dias de Venda',
    columns: [
      {
        name: 'Total Centro (4M)',
        id: 'dias-venda-total',
        show: false,
        isNumeric: true
      },
      {
        name: 'Retira Centro (4M)',
        id: 'dias-venda-retira',
        show: false,
        isNumeric: true
      }
    ]
  },
  {
    group: 'Estoque',
    columns: [
      {
        name: 'Estoque atual',
        id: 'estoque-atual',
        show: true,
        isNumeric: true
      },
      {
        name: 'Estoque Dep. 16',
        id: 'estoque-deposito-16',
        show: true,
        isNumeric: true
      },
      {
        name: 'Estoque em Transito',
        id: 'estoque-transito',
        show: true,
        isNumeric: true
      },
      {
        name: 'Estoque CD',
        id: 'estoque-cd',
        show: true,
        isNumeric: true
      },
      {
        name: 'Peso Unitario',
        id: 'estoque-peso-unit',
        show: true,
        isNumeric: true
      },
      {
        name: 'Custo Unitario',
        id: 'estoque-custo-unit',
        show: true,
        isNumeric: true
      },
      {
        name: 'CMM',
        id: 'estoque-cmm',
        show: true,
        isNumeric: true
      },
      {
        name: 'Primeira Entrada',
        id: 'estoque-primeira-entrada',
        show: true
      },
      {
        name: 'Ultima venda na Loja',
        id: 'estoque-ultima-venda-loja',
        show: true,
        isNumeric: true
      },
      {
        name: 'Ultima venda na Empresa',
        id: 'estoque-ultima-venda-empresa',
        show: true
      },
      {
        name: 'Endereço',
        id: 'estoque-endereco',
        show: true
      },
      {
        name: 'Sortimento',
        id: 'estoque-sortimento',
        show: true
      }
    ]
  }
]

export default parametrizationSupplyHeader
